import {Component, ChangeDetectionStrategy} from '@angular/core';
import {MatCalendar} from '@angular/material/datepicker';
import {MatDialogRef} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';

@Component({
  selector: 'app-calendar-dialog',
  template: `
    <div class="calendar-dialog-container">
      <!-- Header avec titre et bouton fermer -->
      <div class="calendar-header">
        <h2 class="calendar-title">Sélectionner une date</h2>
        <button
          mat-icon-button
          class="close-button"
          (click)="onCancel()"
          aria-label="Fermer">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Calendrier -->
      <mat-calendar
        [(selected)]="selectedDate"
        (selectedChange)="onDateSelected($event)">
      </mat-calendar>

      <!-- Actions -->
      <div class="calendar-actions">
        <button
          mat-button
          color="#45B56F"
          (click)="onCancel()">
          Annuler
        </button>
        <button
          mat-raised-button
          color="#45B56F"
          [disabled]="!selectedDate"
          (click)="onConfirm()">
          Confirmer
        </button>
      </div>
    </div>
  `,
  imports: [
    MatCalendar,
    MatButtonModule,
    MatIconModule
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .calendar-dialog-container {
      background: #fff;
      border-radius: 16px;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
      width: 360px;
      max-width: 90vw;
      overflow: hidden;
    }

    .calendar-header {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      padding: 12px 20px;
      border-bottom: 1px solid #e0e0e0;
      background: linear-gradient(135deg, #45B56F 0%, #205a36 100%);
    }

    .calendar-title {
      margin: 0;
      font-size: 18px;
      font-weight: 500;
      color: #fff;
      text-align: center;
    }

    .close-button {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: rgba(255, 255, 255, 0.9);
      width: 32px;
      height: 32px;
    }

    .close-button:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: #fff;
    }

    mat-calendar {
      padding: 16px;
      width: 100%;
      box-sizing: border-box;
    }

    .calendar-actions {
      display: flex;
      justify-content: flex-end;
      gap: 8px;
      padding: 12px 20px 16px 20px;
      border-top: 1px solid #e0e0e0;
      background-color: #fafafa;
    }

    .calendar-actions button {
      min-width: 80px;
    }

    /* Responsive */
    @media (max-width: 480px) {
      .calendar-dialog-container {
        width: 100%;
        max-width: 100%;
        margin: 0;
        border-radius: 0;
      }

      .calendar-header {
        padding: 10px 16px;
      }

      .calendar-title {
        font-size: 16px;
      }

      mat-calendar {
        padding: 12px;
      }

      .calendar-actions {
        padding: 12px 16px;
      }
    }
  `]
})
export class CalendarDialogComponent {
  selectedDate: Date | null = null;

  constructor(private dialogRef: MatDialogRef<CalendarDialogComponent>) {
    // Supprimer les marges/paddings par défaut du MatDialog
    this.dialogRef.updateSize('auto', 'auto');
    this.dialogRef.addPanelClass('calendar-no-container');
  }

  onDateSelected(date: Date) {
    this.selectedDate = date;
    // Ne pas fermer automatiquement, laisser l'utilisateur confirmer
  }

  onConfirm() {
    if (this.selectedDate) {
      this.dialogRef.close(this.selectedDate);
    }
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
